<template>
<div>
  <div class="page dark new2019">
    

    <div id="about" class="inner inner2">
      <h1>At a Glance</h1>
      <ul>
        <li>32 Channel live recording</li>
        <li>Spacious rooms with exceptional acoustics</li>
        <li>Experienced Engineers</li>
        <li>Beautiful Location</li>
      </ul>
       <!-- <h1>New for 2019</h1> <br />
       All areas of the studio have been massively upgraded for 2019.  
      Full details to follow soon. <br /> <br /> -->
<!-- <strong @click="read_more=!read_more" style="cursor:pointer;"> <span v-if="!read_more">Read More</span> <span v-if="read_more">Read Less</span></strong> -->

    </div>
   </div>
    <!-- <div v-if="read_more" class="extended">
      <div class="inner">
        <strong>Control Room A</strong>
        <ul>
          <li>16 channels of outboard preamps based on vintage Neve and API units</li>
          <li>Analouge outboard EQs and Compressors based on vintage classics such as LA2A, 1176 and Pultec</li>
          <li>World class clocking and conversion from Antelope Audio</li>
        </ul>
        <strong>Control Room B</strong>
        <ul>
          <li>Alternitive room, engineer, equipment list and price point</li>
          <li>16 channels of console-grade preamps from Antelope Audio and Audient</li>
          <li>Real-time digital emulations of classic mics, preamps, compressors, eqs and consoles</li>
        </ul>
        <strong>Live Room</strong>
          <ul>
            <li>Portable Isolation booth from GIK</li>
          </ul>
    </div>
  
    
  </div> -->
</div>
</template>

<script>


export default {
  name: 'new2019',
  data: function(){
    return {
      read_more: false,
    }
  }

}
</script>

<style scoped lang="scss">

.new2019{

  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  background: url("../assets/new_rack.jpg");
  background-position-x: right;
  background-repeat: no-repeat;
  background-position-y: center;
  background-size: auto 100%; 
  min-height: 20vh;
  text-align: left;
  .inner2{
    background-color: rgba(0,0,0,0.6);
    border-radius: 20px;
    max-width: 1200px;
    font-size:large;
    // max-width: 600px;


    // padding:0 5%;

    h1{
      color: orange;
    }

  }
}

.extended{
  background-color: rgb(31, 31, 31);
  padding: 1em;

}

</style>
